import { classNames } from "@utils/classNames";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { LocationType } from "types/misc";

interface Props {}

const options = [
  { value: LocationType.ONSITE, label: "Onsite only" },
  // { value: LocationType.ONSITE_AND_REMOTE, label: "Onsite + Remote" },
  { value: LocationType.REMOTE, label: "Remote only" },
];

export const LocationTypeMenu: FC<Props> = ({}) => {
  // Form state.
  const {
    register,
    control,
    getValues,
    watch,
    setValue,
    // formState: { errors },
  } = useFormContext();

  const locationType = watch("locationType");

  return (
    <div className="mb-1 text-sm font-medium">
      {options.map((option, i) => (
        <button
          key={option.value}
          type="button"
          className={classNames(
            "relative -mr-px mb-1 px-2 py-1 text-xs font-medium hover:z-10",
            locationType === option.value
              ? "text-white bg-black hover:text-white"
              : "text-gray-500 bg-black/5 hover:text-black hover:bg-black/10",
            i === 0 ? "rounded-l" : "",
            i === options.length - 1 ? "rounded-r" : ""
          )}
          onClick={() => {
            const v = locationType === option.value ? null : option.value;
            setValue("locationType", v);
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
